import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddWooCommerceStoreForm} from "./AddWooCommerceStoreForm";
import { withTranslation } from 'react-i18next';

class AddWooCommerceStoreModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(data) {
        this.toggle();
        this.props.afterSuccessfulSubmit(data);
    }

    render() {
        const { t } = this.props;
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}>{t('woocommerce.connect_title')}</ModalHeader>
                <AddWooCommerceStoreForm afterSuccessfulSubmit={this.afterSuccessfulSubmit} />
            </Modal>
        );
    }
}

export const AddWooCommerceStoreModal = withTranslation()(AddWooCommerceStoreModalClass);
